/*
 * Combine Styles
 - - - - - - - - -
 Given two or more css modules, combines them into one css object
 @param styles - two or more css modules (note the spread, so you don't pass in an explicit array)
 */
export const combineStyles = (...styles: Styles[]): Styles => {
  return styles.reduce((obj, item) => Object.assign(obj, item), {});
};
